import { call, put, select } from 'redux-saga/effects';
import { ERROR, setMessage } from '../../containers/FormMessage/actions';
import * as notify from '../../containers/layout/Notifications/actions';
import { serviceUnavailable } from '../app/actions';
import {
  ConnectionError,
  NotFoundError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../app/errors';
import { restartUserJourney } from '../auth/saga';
import { SlipConflictError, SlipExpiredError, SlipUnsupportedShopError } from '../slip/errors';
import { getSlips } from '../slip/storage';
import { isAuthenticated } from '../user/selectors';
import { failure, success } from './actions';
import { getAccountBets, getBets } from './rest';

export default function* root(
  dateFrom = null,
  dateTo = null,
  showActiveSlips = null,
  nextSlip = null
) {
  let results;

  const authenticated = yield select(isAuthenticated);

  try {
    if (authenticated) {
      results = yield call(getAccountBets, dateFrom, dateTo, showActiveSlips, nextSlip);
    } else {
      const betSlips = yield call(getSlips);
      if (!betSlips) {
        throw new UnauthorizedAccessError('No bet slips found');
      }
      results = yield call(getBets, betSlips);
    }

    yield put(success(results));
  } catch (e) {
    yield put(failure(e));

    if (e instanceof ConnectionError) {
      yield put(notify.add('Connection error.', notify.ERROR));
    } else if (e instanceof ServiceUnavailableError) {
      yield put(serviceUnavailable());
    } else if (e instanceof UnauthorizedAccessError || e instanceof NotFoundError) {
      yield call(restartUserJourney);
    } else if (e instanceof SlipConflictError) {
      yield call(restartUserJourney);
      yield put(setMessage(ERROR, 'Cannot view slips that are being tracked by an account'));
    } else if (e instanceof SlipUnsupportedShopError) {
      yield call(restartUserJourney);
      yield put(setMessage(
        ERROR,
        'Sorry, Bet Tracker is currently in limited trial.'
        + ' Check with your local shop for availability.'
      ));
    } else if (e instanceof SlipExpiredError) {
      yield call(restartUserJourney);
      yield put(setMessage(ERROR,
        'Your tracked slips are cleared at the end of each week. '
        + 'Re-enter any slips you\'d like to continue to track. '
        + 'Pick up a card in Shop for unlimited tracking'
      ));
    } else {
      throw e;
    }
  }
}
